export default {
    // 中
    zhCN: {
        activity_code: '活动代码',
        activity_name: '活动名称',
        responsible_party: '责任方',
        release_date: '发布日期',
        data_sources: '数据来源',
        recall_campaign_type: '服务活动类型',
        service_activity_code: '服务活动代码',
        service_activity_name: '服务活动名称',
        buyout_company: '买断公司',
        audit_company: '审核公司',
        currency: '币种',
        money: '金额',
        start_date: '开始日期',
        end_date: '结束日期',
        failure_mode: '失效模式',
        activity_programme: '活动方案',
        improve_handling: '改善措施',
        activity_information: '活动信息',
        vehicle_involved_list: '未完成车辆列表',
        claim_vehicles_list: '索赔发生车辆列表',
        claim_statistics: '索赔统计',
        technical_document_attachments: '技术文档附件',
        vin: 'VIN',
        is_complete: '是否完成',
        warranty_claims: '索赔单号',
        customer: '总代号',
        claim_proportion: '索赔完成率',
        claim_settled_amount: '索赔已结算金额',
        is_claim_again: '是否再索赔',
        cancel_succeed: '取消成功',
        number_of_vehicles_involved: '未完成车辆数量',
        number_of_vehicles_in_which_the_claim_occurred: '索赔发生车辆数量',
        series: '车系',
        platform: '车型平台',
        activity_region: '活动区域',
        activity_vehicleNum: '车辆数量',
        number_of_claims: '索赔数量',
        activity_vehicle: '活动车辆',
        vehicle_total_num: '车辆总数',
    },
    // 英
    enUS: {
        activity_code: 'Activity code',
        activity_name: 'Activity name',
        responsible_party: 'Responsible party',
        release_date: 'Release date',
        data_sources: 'Data sources',
        recall_campaign_type: 'Recall type',
        service_activity_code: 'Service activity code',
        service_activity_name: 'Service activity name',
        buyout_company: 'Buy-off company',
        audit_company: 'Approval company',
        currency: 'Currency',
        money: 'Amount',
        start_date: 'Start date',
        end_date: 'End date',
        failure_mode: 'Failure mode',
        activity_programme: 'Campaign plan',
        improve_handling: 'Improvement measures',
        activity_information: 'Campaign information',
        vehicle_involved_list: 'Incomplete vehicle list',
        claim_vehicles_list: 'Vehicles claim occurred',
        claim_statistics: 'Claim statistics',
        technical_document_attachments: 'Technical document attachments',
        vin: 'VIN',
        is_complete: 'Completed',
        warranty_claims: 'Warranty claim',
        customer: 'Customer',
        claim_proportion: 'Claim completion rate',
        claim_settled_amount: 'Claim settled amount',
        is_claim_again: 'Whether reclaim',
        cancel_succeed: 'Cancel succeed',
        number_of_vehicles_involved: 'Number of incomplete vehicles',
        number_of_vehicles_in_which_the_claim_occurred:
            'Number of vehicles in which the claim occurred',
        series: 'Series',
        platform: 'Vehicle platform',
        activity_region: 'Activity region',
        activity_vehicleNum: 'Activity vehicleNum',
        number_of_claims: 'Number of claims',
        activity_vehicle: 'Activity vehicle',
        vehicle_total_num: 'Total umber of vehicle',
    },
    // 德
    deDE: {
        activity_code: 'Aktivitätscode',
        activity_name: 'Aktivitätsname',
        responsible_party: 'verantwortliche Partei',
        release_date: 'Veröffentlichungsdatum',
        data_sources: 'Datenquellen',
        recall_campaign_type: 'Art der Dienstaktivität',
        service_activity_code: 'Code der Dienstaktivität',
        service_activity_name: 'Name der Dienstaktivität',
        buyout_company: 'Buy-off-Unternehmen',
        audit_company: 'Genehmigungsunternehmen',
        currency: 'Währung',
        money: 'Betrag',
        start_date: 'Startdatum',
        end_date: 'Enddatum',
        failure_mode: 'Fehlermodus',
        activity_programme: 'Kampagnenplan',
        improve_handling: 'Verbesserungsmaßnahmen',
        activity_information: 'Aktivitätsinformationen',
        vehicle_involved_list: 'Unvollständige Fahrzeugliste',
        claim_vehicles_list: 'Fahrzeuge, bei denen Ansprüche geltend gemacht wurden',
        claim_statistics: 'Anspruchsstatistik',
        technical_document_attachments: 'Anlagen technischer Dokumente',
        vin: 'VIN',
        is_complete: 'Abgeschlossen',
        warranty_claims: 'Forderungsnummer',
        customer: 'Allgemeiner Code',
        claim_proportion: 'Anspruchserfüllungsquote',
        claim_settled_amount: 'beglichene Ansprüche',
        is_claim_again: 'Ob Anspruch erneut geltend gemacht wird',
        cancel_succeed: 'Stornierung erfolgreich',
        number_of_vehicles_involved: 'Anzahl unvollständiger Fahrzeuge',
        number_of_vehicles_in_which_the_claim_occurred:
            'Zentrale. Classic meldet abfahrt der fahrzeuge',
        series: 'Fahrzeugserien',
        platform: 'Fahrzeugplattform',
        activity_region: 'Aktivität Region',
        activity_vehicleNum: 'Aktivität Fahrzeugnummer',
        number_of_claims: 'Anzahl der Forderungen',
        activity_vehicle: 'Aktivitätsfahrzeug',
        vehicle_total_num: 'Gesamtanzahl der Fahrzeuge',
    },
    // 法
    frFR: {
        activity_code: 'Code de l\'activité',
        activity_name: 'Nom de l\'activité',
        responsible_party: 'Partie responsable',
        release_date: 'Date de publication',
        data_sources: 'Sources de données',
        recall_campaign_type: 'Type de Rappel',
        service_activity_code: 'Code de la campagne de service',
        service_activity_name: 'Nom de la campagne de service',
        buyout_company: 'Société de rachat',
        audit_company: 'Société d\'approbation',
        currency: 'Monaie',
        money: 'Montant',
        start_date: 'Date de début',
        end_date: 'Date de fin',
        failure_mode: 'Défaillance',
        activity_programme: 'Plan de la campagne',
        improve_handling: 'Solutions',
        activity_information: 'Informations sur la campagnes',
        vehicle_involved_list: 'Liste des véhicules inachevés',
        claim_vehicles_list: 'Réclamation par véhicule',
        claim_statistics: 'Statistiques',
        technical_document_attachments: 'Pièces jointes de document technique',
        vin: 'VIN',
        is_complete: 'Terminé',
        warranty_claims: 'Numéro de réclamation',
        customer: 'Nom de code total',
        claim_proportion: 'Taux d\'achèvement des réclamations',
        claim_settled_amount: 'Montant réglé de la réclamation',
        is_claim_again: 'Récupération ou non',
        cancel_succeed: 'Annulation réussie',
        number_of_vehicles_involved: 'Nombre de véhicules inachevés',
        number_of_vehicles_in_which_the_claim_occurred:
            'Nombre de véhicules impliqués dans la réclamation',
        series: 'Système de voiture',
        platform: 'Plate - forme de modèle de voiture',
        activity_region: 'Activités Région',
        activity_vehicleNum: 'Activité vehicleNum',
        number_of_claims: 'Nombre de réclamations',
        activity_vehicle: 'Véhicule d\'activité',
        vehicle_total_num: 'Nombre total de véhicules',
    },
    // 意大利
    itIT: {
        activity_code: 'Codice attività',
        activity_name: 'Nome attività',
        responsible_party: 'Parte responsabile',
        release_date: 'Data di rilascio',
        data_sources: 'Fonti dati',
        recall_campaign_type: 'Tipo di attività di servizio',
        service_activity_code: 'Codice delle attività di servizio',
        service_activity_name: 'Nome dell’attività di servizio',
        buyout_company: 'Società di acquisto',
        audit_company: 'Società di approvazione',
        currency: 'Valuta',
        money: 'Importo',
        start_date: 'Data di inizio',
        end_date: 'Data di fine',
        failure_mode: 'Modalità di guasto',
        activity_programme: 'Piano della campagna',
        improve_handling: 'Miglioramento delle misure',
        activity_information: 'Informazioni sull\'attività',
        vehicle_involved_list: 'Elenco dei veicoli incompleto',
        claim_vehicles_list: 'Veicoli che hanno avuto un reclamo',
        claim_statistics: 'Statistiche sui reclami',
        technical_document_attachments: 'Allegati documento tecnico',
        vin: 'VIN',
        is_complete: 'Completato',
        warranty_claims: 'Numero della domanda',
        customer: 'Codice generale',
        claim_proportion: 'Tasso di completamento dei crediti',
        claim_settled_amount: 'Importo risolto del reclamo',
        is_claim_again: 'Se riclaimare',
        cancel_succeed: 'Annullamento riuscito',
        number_of_vehicles_involved: 'Numero di veicoli incompleti',
        number_of_vehicles_in_which_the_claim_occurred: 'Numero di veicoli dichiarati',
        series: 'Serie auto',
        platform: 'Piattaforma del veicolo',
        activity_region: 'Attività regione',
        activity_vehicleNum: 'Attività vehicleNum',
        number_of_claims: 'Numero di crediti',
        activity_vehicle: 'Veicolo di attività',
        vehicle_total_num: 'Numero totale di veicoli',
    },
    // 荷兰
    nlNL: {
        activity_code: 'Activiteit code',
        activity_name: 'Activiteit naam',
        responsible_party: 'Verantwoordelijke partij',
        release_date: 'Uitgiftedatum',
        data_sources: 'Gegevensbronnen',
        recall_campaign_type: 'Type dienstactiviteit',
        service_activity_code: 'Code dienstactiviteit',
        service_activity_name: 'Naam dienstactiviteit',
        buyout_company: 'Uitkoopbedrijf',
        audit_company: 'Goedkeuringsbedrijf',
        currency: 'Valuta',
        money: 'Bedrag',
        start_date: 'Startdatum',
        end_date: 'Einddatum',
        failure_mode: 'Foutmodus',
        activity_programme: 'Campagneplan',
        improve_handling: 'Verbeteringsmaatregelen',
        activity_information: 'Activiteitsinformatie',
        vehicle_involved_list: 'Onvolledige voertuiglijst',
        claim_vehicles_list: 'Voertuigen waarvoor een claim is ingediend',
        claim_statistics: 'Claimstatistieken',
        technical_document_attachments: 'Technische documentbijlagen',
        vin: 'VIN',
        is_complete: 'Voltooid',
        warranty_claims: 'Claimnummer',
        customer: 'Algemene code',
        claim_proportion: 'Afwikkelingspercentage',
        claim_settled_amount: 'Afgehandeld bedrag van claim',
        is_claim_again: 'Of opnieuw claimen',
        cancel_succeed: 'Annuleren gelukt',
        number_of_vehicles_involved: 'Aantal onvolledige voertuigen',
        number_of_vehicles_in_which_the_claim_occurred:
            'Het aantal voertuigen waarvoor de claim is ingediend',
        series: 'Autoserie',
        platform: 'Voertuigplatform',
        activity_region: 'Activiteit regio',
        activity_vehicleNum: 'Activiteit vehicleNum',
        number_of_claims: 'Aantal vorderingen',
        activity_vehicle: 'Activiteitsvoertuig',
        vehicle_total_num: 'Totaal aantal voertuigen',
    },
    // 越南
    viVN: {
        activity_code: 'Mã hoạt động',
        activity_name: 'Tên hoạt động',
        responsible_party: 'Bên chịu trách nhiệm',
        release_date: 'Ngày phát hành',
        data_sources: 'Nguồn dữ liệu',
        recall_campaign_type: 'Loại triệu hồi',
        service_activity_code: 'Mã chiến dịch dịch vụ',
        service_activity_name: 'Tên chiến dịch dịch vụ',
        buyout_company: 'Công ty mua lại',
        audit_company: 'Công ty phê duyệt',
        currency: 'Tiền tệ',
        money: 'Giá trị',
        start_date: 'Ngày bắt đầu',
        end_date: 'Ngày kết thúc',
        failure_mode: 'Chế độ lỗi',
        activity_programme: 'Kế hoạch chiến dịch',
        improve_handling: 'Biện pháp cải tiến',
        activity_information: 'Thông tin chiến dịch',
        vehicle_involved_list: 'Danh sách xe chưa hoàn thành',
        claim_vehicles_list: 'Xe yêu cầu đã xẩy ra',
        claim_statistics: 'Thống kê yêu cầu bồi thường',
        technical_document_attachments: 'Tệp đính kèm tài liệu kỹ thuật',
        vin: 'Số khung',
        is_complete: 'Đã hoàn thành',
        warranty_claims: 'Số yêu cầu bảo hành',
        customer: 'Khách hàng',
        claim_proportion: 'Tỷ lệ hoàn thành yêu cầu bồi thường',
        claim_settled_amount: 'Số tiền đã giải quyết yêu cầu bồi thường',
        is_claim_again: 'Có khiếu nại lại hay không',
        cancel_succeed: 'Hủy thành công',
        number_of_vehicles_involved: 'Số lượng xe chưa hoàn thành',
        number_of_vehicles_in_which_the_claim_occurred: 'Số lượng xe yêu cầu bồi thường',
        series: 'Hệ thống xe',
        platform: 'Nền tảng mô hình',
        activity_region: 'Khu vực hoạt động',
        activity_vehicleNum: 'Hoạt động vehicleNum',
        number_of_claims: 'Số lượng yêu cầu',
        activity_vehicle: 'Xe hoạt động',
        vehicle_total_num: 'Tổng số xe',
    },
    // 西班牙
    esES: {
        activity_code: 'Código de la actividad',
        activity_name: 'Nombre de la actividad',
        responsible_party: 'Parte responsable',
        release_date: 'Fecha de publicación',
        data_sources: 'Fuente de datos',
        recall_campaign_type: 'Tipo de RECALL',
        service_activity_code: 'Código de campaña de servicio',
        service_activity_name: 'Nombre de campaña de servicio',
        buyout_company: 'Empresa de compra',
        audit_company: 'Empresa de auditoría',
        currency: 'Moneda',
        money: 'Monto',
        start_date: 'Fecha de inicio',
        end_date: 'Fecha de finalización',
        failure_mode: 'Modo de falla',
        activity_programme: 'Plan de campaña',
        improve_handling: 'Medidas de mejora',
        activity_information: 'Información de campaña',
        vehicle_involved_list: 'Lista de vehículos incompletos',
        claim_vehicles_list: 'Lista de vehículos con reclamación',
        claim_statistics: 'Estadísticas de reclamación',
        technical_document_attachments: 'Adjunto de documento técnico',
        vin: 'VIN',
        is_complete: '¿Completado?',
        warranty_claims: 'Número de reclamación',
        customer: 'Código general',
        claim_proportion: 'Tasa de finalización de la reclamación',
        claim_settled_amount: 'Monto liquidado de reclamación',
        is_claim_again: '¿Reclamación adicional?',
        cancel_succeed: 'Cancelación exitosa',
        number_of_vehicles_involved: 'Cantidad de vehículos incompletos',
        number_of_vehicles_in_which_the_claim_occurred: 'Cantidad de vehículos con reclamación',
        series: 'Sistema de automóviles',
        platform: 'Plataforma de modelos',
        activity_region: 'Área de actividad',
        activity_vehicleNum: 'Actividad vehicleNum',
        number_of_claims: 'Número de reclamaciones',
        activity_vehicle: 'Vehículo de actividad',
        vehicle_total_num: 'Número total de vehículos',
    },
    // 葡萄牙
    ptBR: {
        activity_code: 'Código de atividade',
        activity_name: 'Nome da atividade',
        responsible_party: 'Parte responsável',
        release_date: 'Data de lançamento',
        data_sources: 'Fontes de dados',
        recall_campaign_type: 'Tipo de campanha de recall',
        service_activity_code: 'Código da atividade de serviço',
        service_activity_name: 'Nome da atividade de serviço',
        buyout_company: 'Empresa de recompra',
        audit_company: 'Empresa de auditoria',
        currency: 'Moeda',
        money: 'Valor',
        start_date: 'Data de início',
        end_date: 'Data de término',
        failure_mode: 'Modo de falha',
        activity_programme: 'Programa de atividade',
        improve_handling: 'Melhorar manuseio',
        activity_information: 'Informação da atividade',
        vehicle_involved_list: 'Lista de veículos envolvidos',
        claim_vehicles_list: 'Lista de veículos com reclamações',
        claim_statistics: 'Estatísticas de reclamações',
        technical_document_attachments: 'Anexos de documento técnico',
        vin: 'VIN',
        is_complete: 'Está completo',
        warranty_claims: 'Números de reclamação de garantia',
        customer: 'Cliente',
        claim_proportion: 'Taxa de conclusão do pedido',
        claim_settled_amount: 'Valor das reclamações resolvidas',
        is_claim_again: 'É uma reclamação novamente',
        cancel_succeed: 'Cancelamento bem-sucedido',
        number_of_vehicles_involved: 'Número de veículos envolvidos não concluídos',
        number_of_vehicles_in_which_the_claim_occurred:
            'Número de veículos em que ocorreram reclamações',
        series: 'Série automóvel',
        platform: 'Plataforma do veículo',
        activity_region: 'Zona de acção',
        activity_vehicleNum: 'Atividade vehicleNum',
        number_of_claims: 'Número de pedidos',
        activity_vehicle: 'Veículo de atividade',
        vehicle_total_num: 'Número total de veículos',
    },
    // 波兰
    plPL: {
        activity_code: 'Kod działania',
        activity_name: 'Nazwa działania',
        responsible_party: 'Strona odpowiedzialna',
        release_date: 'Data wydania',
        data_sources: 'Źródło danych',
        recall_campaign_type: 'Typ działania serwisowego / akcji serwisowej',
        service_activity_code: 'Kod akcji serwisowej',
        service_activity_name: 'Nazwa akcji serwisowej',
        buyout_company: 'Firma wykupu',
        audit_company: 'Firma zatwierdzająca',
        currency: 'Waluta',
        money: 'Kwota',
        start_date: 'Data rozpoczęcia',
        end_date: 'Data zakończenia',
        failure_mode: 'Tryb awaryjny',
        activity_programme: 'Plan działań',
        improve_handling: 'Ulepszenie',
        activity_information: 'Informacja na temat działania',
        vehicle_involved_list: 'Lista pojazdów niekompletnych',
        claim_vehicles_list: 'Lista pojazdów ze zgłoszoną reklamacją',
        claim_statistics: 'Statystyki reklamacji',
        technical_document_attachments: 'Załączone dokumenty techniczne',
        vin: 'VIN',
        is_complete: 'Zakończone',
        warranty_claims: 'Numer zgłoszenia reklamacyjnego',
        customer: 'Klient',
        claim_proportion: 'Wskaźnik realizacji roszczeń',
        claim_settled_amount: 'Kwota rozliczenia zgłoszenia',
        is_claim_again: 'Czy zgłoszone ponownie',
        cancel_succeed: 'Anulowanie zakończone pomyślnie',
        number_of_vehicles_involved: 'Liczba niekompletnych pojazdów',
        number_of_vehicles_in_which_the_claim_occurred: 'Liczba pojazdów ze zgłoszoną reklamacją',
        series: 'Seria samochodów',
        platform: 'Platforma pojazdu',
        activity_region: 'Strefa działania',
        activity_vehicleNum: 'Aktywność vehicleNum',
        number_of_claims: 'Liczba roszczeń',
        activity_vehicle: 'Activity vehicle: Pojazd aktywności',
        vehicle_total_num: 'Całkowita liczba pojazdów',
    },
    trTR: {
        activity_code: 'Etkinlik kodu',
        activity_name: 'Etkinlik adı',
        responsible_party: 'Sorumlu birim',
        release_date: 'Çıkış tarihi',
        data_sources: 'Veri kaynakları',
        recall_campaign_type: 'Geri çağırma tipi',
        service_activity_code: 'SERVICE kampanyası kodu',
        service_activity_name: 'SERVICE kampanyası adı',
        buyout_company: 'Satış Şirketi',
        audit_company: 'Onay Şirketi',
        currency: 'Para birimi',
        money: 'Tutar',
        start_date: 'Başlangıç tarihi',
        end_date: 'Bitiş tarihi',
        failure_mode: 'Arıza modu',
        activity_programme: 'Kampanya planı',
        improve_handling: 'Geliştirme ölçüleri',
        activity_information: 'Kampanya bilgisi',
        vehicle_involved_list: 'Tamamlanmamış Araç Listesi',
        claim_vehicles_list: 'Araç kleymi oluşturuldu',
        claim_statistics: 'Kleym istatistikleri',
        technical_document_attachments: 'Tehnik belge ekleri',
        vin: 'VIN',
        is_complete: 'Tamamlandı',
        warranty_claims: 'Garanti Kleymi',
        customer: 'Müşteri',
        claim_proportion: 'Tamamlama oranı',
        claim_settled_amount: 'Kleym tutarı',
        is_claim_again: 'Tekrar kleym edildi mi?',
        cancel_succeed: 'İptal başarılı',
        number_of_vehicles_involved: 'Tamamlanmamış araçların sayısı',
        number_of_vehicles_in_which_the_claim_occurred: 'Kleym yapılan araç sayısı',
        series: 'araç türleri̇',
        platform: 'Araç platformu',
        activity_region: 'eylem bölgesi',
        activity_vehicleNum: 'Etkinlik araçNumarası',
        number_of_claims: 'Talep sayısı',
        activity_vehicle: 'Etkinlik aracı',
        vehicle_total_num: 'Toplam araç sayısı',
    },
    // 捷克语
    csCZ: {
        activity_code: 'Kód aktivity',
        activity_name: 'Název aktivity',
        responsible_party: 'Odpovědná strana',
        release_date: 'Datum vydání',
        data_sources: 'Zdroje dat',
        recall_campaign_type: 'Typ svolávací akce',
        service_activity_code: 'Kód servisní činnosti',
        service_activity_name: 'Název aktivity služby',
        buyout_company: 'Výkupní společnost',
        audit_company: 'Schvalovací společnost',
        currency: 'Měna',
        money: 'Množství',
        start_date: 'Datum zahájení',
        end_date: 'Datum ukončení',
        failure_mode: 'Režim poruchy',
        activity_programme: 'Plán kampaně',
        improve_handling: 'Opatření ke zlepšení',
        activity_information: 'Informace o kampani',
        vehicle_involved_list: 'Neúplný seznam vozidel',
        claim_vehicles_list: 'Došlo k reklamaci vozidel',
        claim_statistics: 'Statistika nároků',
        technical_document_attachments: 'Přílohy technických dokumentů',
        vin: 'VIN',
        is_complete: 'Dokončeno',
        warranty_claims: 'Záruční reklamace',
        customer: 'Zákazník',
        claim_proportion: 'Míra dokončení reklamace',
        claim_settled_amount: 'Vyrovnaná částka pohledávky',
        is_claim_again: 'Zda se jedná o reklamaci',
        cancel_succeed: 'Zrušení bylo úspěšné',
        number_of_vehicles_involved: 'Počet nedokončených vozidel',
        number_of_vehicles_in_which_the_claim_occurred:
            'Počet vozidel, u kterých došlo k reklamaci',
        series: 'Série',
        platform: 'Platforma vozidla',
        activity_region: 'Oblast činnosti',
        activity_vehicleNum: 'Aktivita vozidla (číslo)',
        number_of_claims: 'Počet nároků',
        activity_vehicle: 'Aktivita vozidla',
        vehicle_total_num: 'Celkový počet vozidel',
    },
    // 匈牙利语
    huHU: {
        activity_code: 'Tevékenységkód',
        activity_name: 'Tevékenységnév',
        responsible_party: 'Felelős fél',
        release_date: 'Kiadási dátum',
        data_sources: 'Adatforrások',
        recall_campaign_type: 'Visszahívás típusa',
        service_activity_code: 'Szerviztevékenység kódja',
        service_activity_name: 'Szerviztevékenység neve',
        buyout_company: 'Vásárló vállalat',
        audit_company: 'Jóváhagyó vállalat',
        currency: 'Pénznem',
        money: 'Mennyiség',
        start_date: 'Kezdő dátum',
        end_date: 'Befejező dátum',
        failure_mode: 'Meghibásodási mód',
        activity_programme: 'Kampányterv',
        improve_handling: 'Fejlesztési intézkedések',
        activity_information: 'Kampányinformáció',
        vehicle_involved_list: 'Hiányos járműlista',
        claim_vehicles_list: 'Járműigény történt',
        claim_statistics: 'Igénystatisztikák',
        technical_document_attachments: 'Műszaki dokumentum mellékletek',
        vin: 'Alvázszám',
        is_complete: 'Kész',
        warranty_claims: 'Garanciális igény',
        customer: 'Ügyfél',
        claim_proportion: 'Igényteljesítési arány',
        claim_settled_amount: 'Igényrendezési összeg',
        is_claim_again: 'Újraigénylés szükséges-e',
        cancel_succeed: 'Sikeres megszakítás',
        number_of_vehicles_involved: 'Befejezetlen járművek száma',
        number_of_vehicles_in_which_the_claim_occurred:
            'Járművek száma, amelyeknél az igény felmerült',
        series: 'Sorozat',
        platform: 'Járműplatform',
        activity_region: 'Tevékenységi régió',
        activity_vehicleNum: 'Járművek száma',
        number_of_claims: 'Igények száma',
        activity_vehicle: 'Tevékenységben érintett jármű',
        vehicle_total_num: 'Összes jármű száma',
    },
    // 俄罗斯语
    ruRU: {
        activity_code: 'Код мероприятия',
        activity_name: 'Название мероприятия',
        responsible_party: 'Ответственный',
        release_date: 'Дата выпуска',
        data_sources: 'Источники данных',
        recall_campaign_type: 'Тип отзыва',
        service_activity_code: 'Код сервисной активности',
        service_activity_name: 'Название сервисной активности',
        buyout_company: 'Компания по одобрению',
        audit_company: 'Компания по утверждению',
        currency: 'Валюта',
        money: 'Сумма',
        start_date: 'Дата начала',
        end_date: 'Дата окончания',
        failure_mode: 'Режим отказа',
        activity_programme: 'План кампании',
        improve_handling: 'Меры по улучшению',
        activity_information: 'Информация о кампании',
        vehicle_involved_list: 'Список неполных автомобилей',
        claim_vehicles_list: 'Произошедшие требования',
        claim_statistics: 'Статистика требований',
        technical_document_attachments: 'Вложения технических документов',
        vin: 'VIN',
        is_complete: 'Завершено',
        warranty_claims: 'Гарантийное требование',
        customer: 'Клиент',
        claim_proportion: 'Процент завершения требований',
        claim_settled_amount: 'Сумма урегулированного требования',
        is_claim_again: 'Является ли возвратом',
        cancel_succeed: 'Отмена прошла успешно',
        number_of_vehicles_involved: 'Количество неполных автомобилей',
        number_of_vehicles_in_which_the_claim_occurred:
            'Количество автомобилей, в которых произошло требование',
        series: 'Серия',
        platform: 'Платформа автомобиля',
        activity_region: 'Регион мероприятия',
        activity_vehicleNum: 'Номер автомобиля мероприятия',
        number_of_claims: 'Количество требований',
        activity_vehicle: 'Автомобиль мероприятия',
        vehicle_total_num: 'Общее количество автомобилей',
    },
    // 沙特阿拉伯
    arSA: {
        activity_code: 'رمز النشاط',
        activity_name: 'اسم النشاط',
        responsible_party: 'الطرف المسؤول',
        release_date: 'تاريخ الإصدار',
        data_sources: 'مصادر البيانات',
        recall_campaign_type: 'نوع حملة الخدمة',
        service_activity_code: 'رمز نشاط الخدمة',
        service_activity_name: 'اسم نشاط الخدمة',
        buyout_company: 'شركة الاستحواذ',
        audit_company: 'شركة التدقيق',
        currency: 'العملة',
        money: 'المبلغ',
        start_date: 'تاريخ البدء',
        end_date: 'تاريخ الانتهاء',
        failure_mode: 'وضع الفشل',
        activity_programme: 'برنامج النشاط',
        improve_handling: 'إجراءات التحسين',
        activity_information: 'معلومات النشاط',
        vehicle_involved_list: 'قائمة المركبات غير المكتملة',
        claim_vehicles_list: 'قائمة المركبات التي حدثت لها مطالبات',
        claim_statistics: 'إحصائيات المطالبات',
        technical_document_attachments: 'مرفقات الوثائق الفنية',
        vin: 'VIN',
        is_complete: 'هل تم الانتهاء؟',
        warranty_claims: 'رقم المطالبة',
        customer: 'رمز التاجر العام',
        claim_proportion: 'معدل إنجاز المطالبات',
        claim_settled_amount: 'المبلغ المستقر للمطالبات',
        is_claim_again: 'هل تمت المطالبة مرة أخرى؟',
        cancel_succeed: 'تم الإلغاء بنجاح',
        number_of_vehicles_involved: 'عدد المركبات غير المكتملة',
        number_of_vehicles_in_which_the_claim_occurred: 'عدد المركبات التي حدثت لها مطالبات',
        series: 'سلسلة المركبة',
        platform: 'منصة الطراز',
        activity_region: 'منطقة النشاط',
        activity_vehicleNum: 'عدد المركبات',
        number_of_claims: 'عدد المطالبات',
        activity_vehicle: 'مركبة النشاط',
        vehicle_total_num: 'إجمالي عدد المركبات',
    },
    // 保加利亚
    bgBG: {
        activity_code: 'Код на активността',
        activity_name: 'Име на активността',
        responsible_party: 'Отговорна страна',
        release_date: 'Дата на публикуване',
        data_sources: 'Източници на данни',
        recall_campaign_type: 'Тип на сервизната кампания',
        service_activity_code: 'Код на сервизната активност',
        service_activity_name: 'Име на сервизната активност',
        buyout_company: 'Компания за изкупуване',
        audit_company: 'Одиторска компания',
        currency: 'Валута',
        money: 'Сума',
        start_date: 'Начална дата',
        end_date: 'Крайна дата',
        failure_mode: 'Режим на отказ',
        activity_programme: 'Програма на активността',
        improve_handling: 'Мерки за подобряване',
        activity_information: 'Информация за активността',
        vehicle_involved_list: 'Списък с незавършени превозни средства',
        claim_vehicles_list: 'Списък с превозни средства с предявени искове',
        claim_statistics: 'Статистика на исковете',
        technical_document_attachments: 'Прикачени технически документи',
        vin: 'VIN',
        is_complete: 'Завършено ли е?',
        warranty_claims: 'Номер на гаранционния иск',
        customer: 'Общ код на дилъра',
        claim_proportion: 'Процент на изпълнение на исковете',
        claim_settled_amount: 'Уредена сума по исковете',
        is_claim_again: 'Повторен ли е искът?',
        cancel_succeed: 'Успешно отменено',
        number_of_vehicles_involved: 'Брой незавършени превозни средства',
        number_of_vehicles_in_which_the_claim_occurred: 'Брой превозни средства с предявени искове',
        series: 'Серия на автомобила',
        platform: 'Платформа на модела',
        activity_region: 'Регион на активността',
        activity_vehicleNum: 'Брой превозни средства',
        number_of_claims: 'Брой искове',
        activity_vehicle: 'Превозно средство по активността',
        vehicle_total_num: 'Общ брой превозни средства',
    },
    // 丹麦语
    daDK: {
        activity_code: 'Aktivitetskode',
        activity_name: 'Aktivitetsnavn',
        responsible_party: 'Ansvarlig part',
        release_date: 'Udgivelsesdato',
        data_sources: 'Datakilder',
        recall_campaign_type: 'Servicekampagnetype',
        service_activity_code: 'Serviceaktivitetskode',
        service_activity_name: 'Serviceaktivitetsnavn',
        buyout_company: 'Opkøbsvirksomhed',
        audit_company: 'Revisionsfirma',
        currency: 'Valuta',
        money: 'Beløb',
        start_date: 'Startdato',
        end_date: 'Slutdato',
        failure_mode: 'Fejltilstand',
        activity_programme: 'Aktivitetsprogram',
        improve_handling: 'Forbedringsforanstaltninger',
        activity_information: 'Aktivitetsoplysninger',
        vehicle_involved_list: 'Liste over ufærdige køretøjer',
        claim_vehicles_list: 'Liste over køretøjer med skadesanmeldelser',
        claim_statistics: 'Skadesstatistik',
        technical_document_attachments: 'Vedhæftede tekniske dokumenter',
        vin: 'VIN',
        is_complete: 'Er færdiggjort?',
        warranty_claims: 'Garantiklagesnummer',
        customer: 'Hovedforhandlerkode',
        claim_proportion: 'Afslutningsprocent for skader',
        claim_settled_amount: 'Afregnet skadebeløb',
        is_claim_again: 'Er der indgivet ny klage?',
        cancel_succeed: 'Annullering lykkedes',
        number_of_vehicles_involved: 'Antal ufærdige køretøjer',
        number_of_vehicles_in_which_the_claim_occurred: 'Antal køretøjer med skadesanmeldelser',
        series: 'Bilmærke/serie',
        platform: 'Modelplatform',
        activity_region: 'Aktivitetsregion',
        activity_vehicleNum: 'Antal køretøjer',
        number_of_claims: 'Antal skader',
        activity_vehicle: 'Aktivitetskøretøj',
        vehicle_total_num: 'Samlet antal køretøjer',
    },
    // 芬兰语
    fiFI: {
        activity_code: 'Toimintakoodi',
        activity_name: 'Toiminnan nimi',
        responsible_party: 'Vastuutaho',
        release_date: 'Julkaisupäivämäärä',
        data_sources: 'Tietolähteet',
        recall_campaign_type: 'Huoltokampanjatyypin',
        service_activity_code: 'Huoltotoiminnan koodi',
        service_activity_name: 'Huoltotoiminnan nimi',
        buyout_company: 'Ostoyhtiö',
        audit_company: 'Tarkastusyritys',
        currency: 'Valuutta',
        money: 'Summa',
        start_date: 'Aloituspäivämäärä',
        end_date: 'Päättymispäivämäärä',
        failure_mode: 'Vikamuoto',
        activity_programme: 'Toimintaohjelma',
        improve_handling: 'Parannustoimenpiteet',
        activity_information: 'Toimintatiedot',
        vehicle_involved_list: 'Keskeneräisten ajoneuvojen luettelo',
        claim_vehicles_list: 'Vahingon saaneiden ajoneuvojen luettelo',
        claim_statistics: 'Vahinkotilastot',
        technical_document_attachments: 'Teknisten asiakirjojen liitteet',
        vin: 'VIN',
        is_complete: 'Valmis?',
        warranty_claims: 'Takuivaatimusnumero',
        customer: 'Pääasiamieskoodi',
        claim_proportion: 'Vahinkojen hoitoprosentti',
        claim_settled_amount: 'Hoitetut vahingot yhteensä',
        is_claim_again: 'Onko vaatimus jätetty uudelleen?',
        cancel_succeed: 'Peruutus onnistui',
        number_of_vehicles_involved: 'Keskeneräisten ajoneuvojen määrä',
        number_of_vehicles_in_which_the_claim_occurred: 'Vahingon saaneiden ajoneuvojen määrä',
        series: 'Ajoneuvosarja',
        platform: 'Mallialusta',
        activity_region: 'Toiminta-alue',
        activity_vehicleNum: 'Ajoneuvojen määrä',
        number_of_claims: 'Vahinkojen määrä',
        activity_vehicle: 'Toiminta-ajoneuvo',
        vehicle_total_num: 'Ajoneuvojen kokonaismäärä',
    },
    // 繁体中文台湾
    zhTW: {
        activity_code: '活動代碼',
        activity_name: '活動名稱',
        responsible_party: '責任方',
        release_date: '發布日期',
        data_sources: '資料來源',
        recall_campaign_type: '服務活動類型',
        service_activity_code: '服務活動代碼',
        service_activity_name: '服務活動名稱',
        buyout_company: '買斷公司',
        audit_company: '審核公司',
        currency: '幣別',
        money: '金額',
        start_date: '開始日期',
        end_date: '結束日期',
        failure_mode: '失效模式',
        activity_programme: '活動方案',
        improve_handling: '改善措施',
        activity_information: '活動資訊',
        vehicle_involved_list: '未完成車輛清單',
        claim_vehicles_list: '理賠發生車輛清單',
        claim_statistics: '理賠統計',
        technical_document_attachments: '技術文件附件',
        vin: 'VIN',
        is_complete: '是否完成',
        warranty_claims: '理賠單號',
        customer: '總代理代號',
        claim_proportion: '理賠完成率',
        claim_settled_amount: '理賠已結算金額',
        is_claim_again: '是否再次理賠',
        cancel_succeed: '取消成功',
        number_of_vehicles_involved: '未完成車輛數量',
        number_of_vehicles_in_which_the_claim_occurred: '理賠發生車輛數量',
        series: '車系',
        platform: '車型平台',
        activity_region: '活動區域',
        activity_vehicleNum: '車輛數量',
        number_of_claims: '理賠數量',
        activity_vehicle: '活動車輛',
        vehicle_total_num: '車輛總數',
    },
    // 克罗地亚
    hrHR: {
        activity_code: 'Kôd aktivnosti',
        activity_name: 'Naziv aktivnosti',
        responsible_party: 'Odgovorna strana',
        release_date: 'Datum objave',
        data_sources: 'Izvori podataka',
        recall_campaign_type: 'Vrsta servisne kampanje',
        service_activity_code: 'Kôd servisne aktivnosti',
        service_activity_name: 'Naziv servisne aktivnosti',
        buyout_company: 'Kupovna tvrtka',
        audit_company: 'Revizorska tvrtka',
        currency: 'Valuta',
        money: 'Iznos',
        start_date: 'Datum početka',
        end_date: 'Datum završetka',
        failure_mode: 'Način otkaza',
        activity_programme: 'Program aktivnosti',
        improve_handling: 'Mjere za poboljšanje',
        activity_information: 'Informacije o aktivnosti',
        vehicle_involved_list: 'Popis nezavršenih vozila',
        claim_vehicles_list: 'Popis vozila s prijavljenim zahtjevima',
        claim_statistics: 'Statistika zahtjeva',
        technical_document_attachments: 'Prilozi tehničkih dokumenata',
        vin: 'VIN',
        is_complete: 'Je li dovršeno?',
        warranty_claims: 'Broj zahtjeva za jamstvo',
        customer: 'Glavni kod distributera',
        claim_proportion: 'Postotak obrađenih zahtjeva',
        claim_settled_amount: 'Isplaćeni iznos zahtjeva',
        is_claim_again: 'Je li ponovno podnesen zahtjev?',
        cancel_succeed: 'Uspješno otkazano',
        number_of_vehicles_involved: 'Broj nezavršenih vozila',
        number_of_vehicles_in_which_the_claim_occurred: 'Broj vozila s prijavljenim zahtjevima',
        series: 'Serija vozila',
        platform: 'Platforma modela',
        activity_region: 'Regija aktivnosti',
        activity_vehicleNum: 'Broj vozila',
        number_of_claims: 'Broj zahtjeva',
        activity_vehicle: 'Vozilo aktivnosti',
        vehicle_total_num: 'Ukupan broj vozila',
    },
    // 拉脱维亚
    lvLV: {
        activity_code: 'Darbības kods',
        activity_name: 'Darbības nosaukums',
        responsible_party: 'Atbildīgā puse',
        release_date: 'Publicēšanas datums',
        data_sources: 'Datu avoti',
        recall_campaign_type: 'Apkalpošanas kampaņas veids',
        service_activity_code: 'Apkalpošanas darbības kods',
        service_activity_name: 'Apkalpošanas darbības nosaukums',
        buyout_company: 'Pirkšanas uzņēmums',
        audit_company: 'Revīzijas uzņēmums',
        currency: 'Valūta',
        money: 'Summa',
        start_date: 'Sākuma datums',
        end_date: 'Beigu datums',
        failure_mode: 'Kļūmes režīms',
        activity_programme: 'Darbības programma',
        improve_handling: 'Uzlabošanas pasākumi',
        activity_information: 'Darbības informācija',
        vehicle_involved_list: 'Neapstrādāto transportlīdzekļu saraksts',
        claim_vehicles_list: 'Transportlīdzekļu saraksts ar prasībām',
        claim_statistics: 'Prasību statistika',
        technical_document_attachments: 'Tehnisko dokumentu pielikumi',
        vin: 'VIN',
        is_complete: 'Vai pabeigts?',
        warranty_claims: 'Garantijas prasījuma numurs',
        customer: 'Galvenā aģenta kods',
        claim_proportion: 'Prasību izpildes procents',
        claim_settled_amount: 'Nokārtotā prasījuma summa',
        is_claim_again: 'Vai atkārtota prasība?',
        cancel_succeed: 'Atcelšana veiksmīga',
        number_of_vehicles_involved: 'Neapstrādāto transportlīdzekļu skaits',
        number_of_vehicles_in_which_the_claim_occurred: 'Transportlīdzekļu skaits ar prasībām',
        series: 'Automobiļu sērija',
        platform: 'Modeļa platforma',
        activity_region: 'Darbības reģions',
        activity_vehicleNum: 'Transportlīdzekļu skaits',
        number_of_claims: 'Prasību skaits',
        activity_vehicle: 'Darbības transportlīdzeklis',
        vehicle_total_num: 'Kopējais transportlīdzekļu skaits',
    },
    // 立陶宛
    ltLT: {
        activity_code: 'Veiklos kodas',
        activity_name: 'Veiklos pavadinimas',
        responsible_party: 'Atsakingoji šalis',
        release_date: 'Išleidimo data',
        data_sources: 'Duomenų šaltiniai',
        recall_campaign_type: 'Aptarnavimo kampanijos tipas',
        service_activity_code: 'Aptarnavimo veiklos kodas',
        service_activity_name: 'Aptarnavimo veiklos pavadinimas',
        buyout_company: 'Įsigijimo įmonė',
        audit_company: 'Audito įmonė',
        currency: 'Valiuta',
        money: 'Suma',
        start_date: 'Pradžios data',
        end_date: 'Pabaigos data',
        failure_mode: 'Nepavykimo būdas',
        activity_programme: 'Veiklos programa',
        improve_handling: 'Pagerinimo priemonės',
        activity_information: 'Veiklos informacija',
        vehicle_involved_list: 'Neužbaigtų transporto priemonių sąrašas',
        claim_vehicles_list: 'Transporto priemonių, dėl kurių pateikti pretenzijų, sąrašas',
        claim_statistics: 'Pretenzijų statistika',
        technical_document_attachments: 'Techninių dokumentų priedai',
        vin: 'VIN',
        is_complete: 'Ar užbaigta?',
        warranty_claims: 'Garantinio pretenzijos numeris',
        customer: 'Pagrindinio atstovo kodas',
        claim_proportion: 'Pretenzijų įvykdymo procentas',
        claim_settled_amount: 'Apskaičiuota pretenzijų suma',
        is_claim_again: 'Ar pateikta pakartotinė pretenzija?',
        cancel_succeed: 'Atšaukimas sėkmingas',
        number_of_vehicles_involved: 'Neužbaigtų transporto priemonių skaičius',
        number_of_vehicles_in_which_the_claim_occurred:
            'Transporto priemonių, dėl kurių pateikta pretenzija, skaičius',
        series: 'Automobilių serija',
        platform: 'Modelio platforma',
        activity_region: 'Veiklos regionas',
        activity_vehicleNum: 'Transporto priemonių skaičius',
        number_of_claims: 'Pretenzijų skaičius',
        activity_vehicle: 'Veiklos transporto priemonė',
        vehicle_total_num: 'Bendras transporto priemonių skaičius',
    },
    // 罗马尼亚
    roRO: {
        activity_code: 'Cod activitate',
        activity_name: 'Nume activitate',
        responsible_party: 'Parte responsabilă',
        release_date: 'Data lansării',
        data_sources: 'Surse de date',
        recall_campaign_type: 'Tip campanie de service',
        service_activity_code: 'Cod activitate service',
        service_activity_name: 'Nume activitate service',
        buyout_company: 'Companie de cumpărare',
        audit_company: 'Companie de audit',
        currency: 'Monedă',
        money: 'Sumă',
        start_date: 'Dată început',
        end_date: 'Dată încheiere',
        failure_mode: 'Mod de defectare',
        activity_programme: 'Program activitate',
        improve_handling: 'Măsuri de îmbunătățire',
        activity_information: 'Informații despre activitate',
        vehicle_involved_list: 'Listă vehicule nefinalizate',
        claim_vehicles_list: 'Listă vehicule cu reclamații',
        claim_statistics: 'Statistici reclamații',
        technical_document_attachments: 'Atașamente documente tehnice',
        vin: 'VIN',
        is_complete: 'Este finalizat?',
        warranty_claims: 'Număr reclamație garanție',
        customer: 'Cod distribuitor principal',
        claim_proportion: 'Rată finalizare reclamații',
        claim_settled_amount: 'Sumă decontată reclamații',
        is_claim_again: 'Este reclamație repetată?',
        cancel_succeed: 'Anulare reușită',
        number_of_vehicles_involved: 'Număr vehicule nefinalizate',
        number_of_vehicles_in_which_the_claim_occurred: 'Număr vehicule cu reclamații',
        series: 'Serie vehicul',
        platform: 'Platformă model',
        activity_region: 'Zonă activitate',
        activity_vehicleNum: 'Număr vehicule',
        number_of_claims: 'Număr reclamații',
        activity_vehicle: 'Vehicul activitate',
        vehicle_total_num: 'Număr total vehicule',
    },
    // 挪威博克马尔
    nbNO: {
        activity_code: 'Aktivitetskode',
        activity_name: 'Aktivitetsnavn',
        responsible_party: 'Ansvarlig part',
        release_date: 'Utgivelsesdato',
        data_sources: 'Datakilder',
        recall_campaign_type: 'Servicetiltakstype',
        service_activity_code: 'Servicetiltakskode',
        service_activity_name: 'Servicetiltaksnavn',
        buyout_company: 'Oppkjøpsfirma',
        audit_company: 'Revisjonsfirma',
        currency: 'Valuta',
        money: 'Beløp',
        start_date: 'Startdato',
        end_date: 'Sluttdato',
        failure_mode: 'Feilmodus',
        activity_programme: 'Aktivitetsprogram',
        improve_handling: 'Forbedringstiltak',
        activity_information: 'Aktivitetsinformasjon',
        vehicle_involved_list: 'Liste over uførte kjøretøy',
        claim_vehicles_list: 'Liste over kjøretøy med reklamasjoner',
        claim_statistics: 'Reklamasjonsstatistikk',
        technical_document_attachments: 'Vedlegg med tekniske dokumenter',
        vin: 'VIN',
        is_complete: 'Er fullført?',
        warranty_claims: 'Garantireklamasjonsnummer',
        customer: 'Hovedforhandlerkode',
        claim_proportion: 'Fullføringsgrad for reklamasjoner',
        claim_settled_amount: 'Avviklet beløp for reklamasjoner',
        is_claim_again: 'Er det ny reklamasjon?',
        cancel_succeed: 'Avbestilling vellykket',
        number_of_vehicles_involved: 'Antall uførte kjøretøy',
        number_of_vehicles_in_which_the_claim_occurred: 'Antall kjøretøy med reklamasjoner',
        series: 'Bilserie',
        platform: 'Modellplattform',
        activity_region: 'Aktivitetsregion',
        activity_vehicleNum: 'Antall kjøretøy',
        number_of_claims: 'Antall reklamasjoner',
        activity_vehicle: 'Aktivitetskjøretøy',
        vehicle_total_num: 'Totalt antall kjøretøy',
    },
    // 葡萄牙语巴西
    ptBX: {
        activity_code: 'Código da atividade',
        activity_name: 'Nome da atividade',
        responsible_party: 'Parte responsável',
        release_date: 'Data de lançamento',
        data_sources: 'Fontes de dados',
        recall_campaign_type: 'Tipo de campanha de serviço',
        service_activity_code: 'Código da atividade de serviço',
        service_activity_name: 'Nome da atividade de serviço',
        buyout_company: 'Empresa de compra',
        audit_company: 'Empresa de auditoria',
        currency: 'Moeda',
        money: 'Valor',
        start_date: 'Data de início',
        end_date: 'Data de término',
        failure_mode: 'Modo de falha',
        activity_programme: 'Programa da atividade',
        improve_handling: 'Medidas corretivas',
        activity_information: 'Informações da atividade',
        vehicle_involved_list: 'Lista de veículos não concluídos',
        claim_vehicles_list: 'Lista de veículos com sinistros',
        claim_statistics: 'Estatísticas de sinistros',
        technical_document_attachments: 'Anexos de documentos técnicos',
        vin: 'VIN',
        is_complete: 'Está concluído?',
        warranty_claims: 'Número do sinistro',
        customer: 'Código do distribuidor principal',
        claim_proportion: 'Taxa de conclusão de sinistros',
        claim_settled_amount: 'Valor liquidado de sinistros',
        is_claim_again: 'É um novo sinistro?',
        cancel_succeed: 'Cancelamento bem-sucedido',
        number_of_vehicles_involved: 'Número de veículos não concluídos',
        number_of_vehicles_in_which_the_claim_occurred: 'Número de veículos com sinistros',
        series: 'Série do veículo',
        platform: 'Plataforma do modelo',
        activity_region: 'Região da atividade',
        activity_vehicleNum: 'Quantidade de veículos',
        number_of_claims: 'Número de sinistros',
        activity_vehicle: 'Veículo da atividade',
        vehicle_total_num: 'Número total de veículos',
    },
    // 瑞典语
    svSE: {
        activity_code: 'Aktivitetskod',
        activity_name: 'Aktivitetsnamn',
        responsible_party: 'Ansvarig part',
        release_date: 'Publiceringsdatum',
        data_sources: 'Datakällor',
        recall_campaign_type: 'Servicekampanjtyp',
        service_activity_code: 'Serviceaktivitetskod',
        service_activity_name: 'Serviceaktivitetsnamn',
        buyout_company: 'Uppköpande företag',
        audit_company: 'Revisionsföretag',
        currency: 'Valuta',
        money: 'Belopp',
        start_date: 'Startdatum',
        end_date: 'Slutdatum',
        failure_mode: 'Feltyp',
        activity_programme: 'Aktivitetsprogram',
        improve_handling: 'Förbättringsåtgärder',
        activity_information: 'Aktivitetsinformation',
        vehicle_involved_list: 'Lista över ofärdiga fordon',
        claim_vehicles_list: 'Lista över fordon med ersättningskrav',
        claim_statistics: 'Statistik över ersättningskrav',
        technical_document_attachments: 'Bilagor med tekniska dokument',
        vin: 'VIN',
        is_complete: 'Är slutfört?',
        warranty_claims: 'Garantikräv-nummer',
        customer: 'Huvudåterförsäljarkod',
        claim_proportion: 'Andel avslutade ersättningskrav',
        claim_settled_amount: 'Utbetalt belopp för ersättningskrav',
        is_claim_again: 'Är det ett nytt krav?',
        cancel_succeed: 'Avbrytning lyckades',
        number_of_vehicles_involved: 'Antal ofärdiga fordon',
        number_of_vehicles_in_which_the_claim_occurred: 'Antal fordon med ersättningskrav',
        series: 'Fordonsmodellserie',
        platform: 'Modellplattform',
        activity_region: 'Aktivitetsregion',
        activity_vehicleNum: 'Antal fordon',
        number_of_claims: 'Antal ersättningskrav',
        activity_vehicle: 'Aktivitetsfordon',
        vehicle_total_num: 'Totalt antal fordon',
    },
    // 斯洛伐克
    skSK: {
        activity_code: 'Kód aktivity',
        activity_name: 'Názov aktivity',
        responsible_party: 'Zodpovedná strana',
        release_date: 'Dátum vydania',
        data_sources: 'Zdroje údajov',
        recall_campaign_type: 'Typ servisnej kampane',
        service_activity_code: 'Kód servisnej aktivity',
        service_activity_name: 'Názov servisnej aktivity',
        buyout_company: 'Spoločnosť na odkúpenie',
        audit_company: 'Audítorská spoločnosť',
        currency: 'Mena',
        money: 'Suma',
        start_date: 'Dátum začiatku',
        end_date: 'Dátum ukončenia',
        failure_mode: 'Režim poruchy',
        activity_programme: 'Program aktivity',
        improve_handling: 'Opatrenia na zlepšenie',
        activity_information: 'Informácie o aktivite',
        vehicle_involved_list: 'Zoznam neukončených vozidiel',
        claim_vehicles_list: 'Zoznam vozidiel s nárokmi',
        claim_statistics: 'Štatistika nárokov',
        technical_document_attachments: 'Prílohy technických dokumentov',
        vin: 'VIN',
        is_complete: 'Je dokončené?',
        warranty_claims: 'Číslo záručného nároku',
        customer: 'Kód hlavného distribútora',
        claim_proportion: 'Percento vybavených nárokov',
        claim_settled_amount: 'Vyrovnaná suma nárokov',
        is_claim_again: 'Je to opakovaný nárok?',
        cancel_succeed: 'Zrušenie úspešné',
        number_of_vehicles_involved: 'Počet neukončených vozidiel',
        number_of_vehicles_in_which_the_claim_occurred: 'Počet vozidiel s nárokmi',
        series: 'Séria vozidla',
        platform: 'Platforma modelu',
        activity_region: 'Región aktivity',
        activity_vehicleNum: 'Počet vozidiel',
        number_of_claims: 'Počet nárokov',
        activity_vehicle: 'Vozidlo aktivity',
        vehicle_total_num: 'Celkový počet vozidiel',
    },
    // 斯洛文尼亚
    slSI: {
        activity_code: 'Koda dejavnosti',
        activity_name: 'Ime dejavnosti',
        responsible_party: 'Odgovorna stranka',
        release_date: 'Datum objave',
        data_sources: 'Viri podatkov',
        recall_campaign_type: 'Vrsta servisne akcije',
        service_activity_code: 'Koda servisne dejavnosti',
        service_activity_name: 'Ime servisne dejavnosti',
        buyout_company: 'Podjetje za odkup',
        audit_company: 'Revizijsko podjetje',
        currency: 'Valuta',
        money: 'Znesek',
        start_date: 'Datum začetka',
        end_date: 'Datum konca',
        failure_mode: 'Način odpovedi',
        activity_programme: 'Program dejavnosti',
        improve_handling: 'Ukrepi za izboljšavo',
        activity_information: 'Informacije o dejavnosti',
        vehicle_involved_list: 'Seznam nedokončanih vozil',
        claim_vehicles_list: 'Seznam vozil s prijavi zahtevkov',
        claim_statistics: 'Statistika zahtevkov',
        technical_document_attachments: 'Priloge tehničnih dokumentov',
        vin: 'VIN',
        is_complete: 'Ali je dokončano?',
        warranty_claims: 'Številka garancijskega zahtevka',
        customer: 'Koda glavnega distributerja',
        claim_proportion: 'Stopnja izpolnjenih zahtevkov',
        claim_settled_amount: 'Poravnani znesek zahtevkov',
        is_claim_again: 'Ali gre za ponovni zahtevek?',
        cancel_succeed: 'Uspešno preklicano',
        number_of_vehicles_involved: 'Število nedokončanih vozil',
        number_of_vehicles_in_which_the_claim_occurred: 'Število vozil s prijavljenimi zahtevki',
        series: 'Serija vozila',
        platform: 'Platforma modela',
        activity_region: 'Regija dejavnosti',
        activity_vehicleNum: 'Število vozil',
        number_of_claims: 'Število zahtevkov',
        activity_vehicle: 'Vozilo dejavnosti',
        vehicle_total_num: 'Skupno število vozil',
    },
    // 泰语
    thTH: {
        activity_code: 'รหัสกิจกรรม',
        activity_name: 'ชื่อกิจกรรม',
        responsible_party: 'ผู้รับผิดชอบ',
        release_date: 'วันที่เผยแพร่',
        data_sources: 'แหล่งข้อมูล',
        recall_campaign_type: 'ประเภทแคมเปญบริการ',
        service_activity_code: 'รหัสกิจกรรมบริการ',
        service_activity_name: 'ชื่อกิจกรรมบริการ',
        buyout_company: 'บริษัทซื้อขาด',
        audit_company: 'บริษัทตรวจสอบ',
        currency: 'สกุลเงิน',
        money: 'จำนวนเงิน',
        start_date: 'วันที่เริ่มต้น',
        end_date: 'วันที่สิ้นสุด',
        failure_mode: 'โหมดความล้มเหลว',
        activity_programme: 'แผนกิจกรรม',
        improve_handling: 'มาตรการปรับปรุง',
        activity_information: 'ข้อมูลกิจกรรม',
        vehicle_involved_list: 'รายการรถที่ยังไม่เสร็จสมบูรณ์',
        claim_vehicles_list: 'รายการรถที่เกิดการเคลม',
        claim_statistics: 'สถิติการเคลม',
        technical_document_attachments: 'เอกสารแนบทางเทคนิค',
        vin: 'VIN',
        is_complete: 'เสร็จสมบูรณ์หรือไม่',
        warranty_claims: 'หมายเลขเคลม',
        customer: 'รหัสตัวแทนหลัก',
        claim_proportion: 'อัตราการเคลมสำเร็จ',
        claim_settled_amount: 'จำนวนเงินที่เคลมแล้ว',
        is_claim_again: 'เคลมซ้ำหรือไม่',
        cancel_succeed: 'ยกเลิกสำเร็จ',
        number_of_vehicles_involved: 'จำนวนรถที่ยังไม่เสร็จสมบูรณ์',
        number_of_vehicles_in_which_the_claim_occurred: 'จำนวนรถที่เกิดการเคลม',
        series: 'รุ่นรถ',
        platform: 'แพลตฟอร์มโมเดล',
        activity_region: 'พื้นที่กิจกรรม',
        activity_vehicleNum: 'จำนวนรถ',
        number_of_claims: 'จำนวนการเคลม',
        activity_vehicle: 'รถกิจกรรม',
        vehicle_total_num: 'จำนวนรถทั้งหมด',
    },
    // 乌克兰语
    ukUA: {
        activity_code: 'Код активності',
        activity_name: 'Назва активності',
        responsible_party: 'Відповідальна сторона',
        release_date: 'Дата випуску',
        data_sources: 'Джерела даних',
        recall_campaign_type: 'Тип сервісної кампанії',
        service_activity_code: 'Код сервісної активності',
        service_activity_name: 'Назва сервісної активності',
        buyout_company: 'Компанія з викупу',
        audit_company: 'Аудиторська компанія',
        currency: 'Валюта',
        money: 'Сума',
        start_date: 'Дата початку',
        end_date: 'Дата завершення',
        failure_mode: 'Режим відмови',
        activity_programme: 'Програма активності',
        improve_handling: 'Заходи щодо покращення',
        activity_information: 'Інформація про активність',
        vehicle_involved_list: 'Список незавершених транспортних засобів',
        claim_vehicles_list: 'Список транспортних засобів із заявками на відшкодування',
        claim_statistics: 'Статистика заявок на відшкодування',
        technical_document_attachments: 'Додатки технічних документів',
        vin: 'VIN',
        is_complete: 'Чи завершено?',
        warranty_claims: 'Номер гарантійної заяви',
        customer: 'Код головного дистриб’ютора',
        claim_proportion: 'Відсоток виконаних заявок',
        claim_settled_amount: 'Врегульована сума заявок',
        is_claim_again: 'Чи повторна заява?',
        cancel_succeed: 'Скасовано успішно',
        number_of_vehicles_involved: 'Кількість незавершених транспортних засобів',
        number_of_vehicles_in_which_the_claim_occurred:
            'Кількість транспортних засобів із заявками',
        series: 'Серія автомобіля',
        platform: 'Платформа моделі',
        activity_region: 'Регіон активності',
        activity_vehicleNum: 'Кількість транспортних засобів',
        number_of_claims: 'Кількість заявок',
        activity_vehicle: 'Транспортний засіб активності',
        vehicle_total_num: 'Загальна кількість транспортних засобів',
    },
    // 希腊语
    elGR: {
        activity_code: 'Κωδικός δραστηριότητας',
        activity_name: 'Όνομα δραστηριότητας',
        responsible_party: 'Υπεύθυνο μέρος',
        release_date: 'Ημερομηνία έκδοσης',
        data_sources: 'Πηγές δεδομένων',
        recall_campaign_type: 'Τύπος εκστρατείας σέρβις',
        service_activity_code: 'Κωδικός δραστηριότητας σέρβις',
        service_activity_name: 'Όνομα δραστηριότητας σέρβις',
        buyout_company: 'Εταιρεία εξαγοράς',
        audit_company: 'Ελεγκτική εταιρεία',
        currency: 'Νόμισμα',
        money: 'Ποσό',
        start_date: 'Ημερομηνία έναρξης',
        end_date: 'Ημερομηνία λήξης',
        failure_mode: 'Τρόπος αποτυχίας',
        activity_programme: 'Πρόγραμμα δραστηριότητας',
        improve_handling: 'Μέτρα βελτίωσης',
        activity_information: 'Πληροφορίες δραστηριότητας',
        vehicle_involved_list: 'Λίστα μη ολοκληρωμένων οχημάτων',
        claim_vehicles_list: 'Λίστα οχημάτων με αξιώσεις',
        claim_statistics: 'Στατιστικά αξιώσεων',
        technical_document_attachments: 'Συνημμένα τεχνικά έγγραφα',
        vin: 'VIN',
        is_complete: 'Ολοκληρώθηκε;',
        warranty_claims: 'Αριθμός αξίωσης εγγύησης',
        customer: 'Κωδικός κύριου διανομέα',
        claim_proportion: 'Ποσοστό ολοκλήρωσης αξιώσεων',
        claim_settled_amount: 'Εξοφλημένο ποσό αξιώσεων',
        is_claim_again: 'Επαναλαμβανόμενη αξίωση;',
        cancel_succeed: 'Επιτυχής ακύρωση',
        number_of_vehicles_involved: 'Αριθμός μη ολοκληρωμένων οχημάτων',
        number_of_vehicles_in_which_the_claim_occurred: 'Αριθμός οχημάτων με αξιώσεις',
        series: 'Σειρά οχήματος',
        platform: 'Πλατφόρμα μοντέλου',
        activity_region: 'Περιοχή δραστηριότητας',
        activity_vehicleNum: 'Αριθμός οχημάτων',
        number_of_claims: 'Αριθμός αξιώσεων',
        activity_vehicle: 'Όχημα δραστηριότητας',
        vehicle_total_num: 'Συνολικός αριθμός οχημάτων',
    },
    // 爱沙尼亚
    etEE: {
        activity_code: 'Tegevuse kood',
        activity_name: 'Tegevuse nimi',
        responsible_party: 'Vastutav osapool',
        release_date: 'Väljalaske kuupäev',
        data_sources: 'Andmeallikad',
        recall_campaign_type: 'Teeninduskampaania tüüp',
        service_activity_code: 'Teenindustegevuse kood',
        service_activity_name: 'Teenindustegevuse nimi',
        buyout_company: 'Ostufirma',
        audit_company: 'Auditeerimisfirma',
        currency: 'Valuuta',
        money: 'Summa',
        start_date: 'Alguskuupäev',
        end_date: 'Lõpukuupäev',
        failure_mode: 'Tõrke režiim',
        activity_programme: 'Tegevuse programm',
        improve_handling: 'Parandusmeetmed',
        activity_information: 'Tegevuse teave',
        vehicle_involved_list: 'Lõpetamata sõidukite loend',
        claim_vehicles_list: 'Nõudega sõidukite loend',
        claim_statistics: 'Nõuete statistika',
        technical_document_attachments: 'Tehniliste dokumentide manused',
        vin: 'VIN',
        is_complete: 'Kas on lõpetatud?',
        warranty_claims: 'Garantiinõude number',
        customer: 'Peaagentuuri kood',
        claim_proportion: 'Nõuete täitmise protsent',
        claim_settled_amount: 'Tasutud nõude summa',
        is_claim_again: 'Kas on korduv nõue?',
        cancel_succeed: 'Tühistamine õnnestus',
        number_of_vehicles_involved: 'Lõpetamata sõidukite arv',
        number_of_vehicles_in_which_the_claim_occurred: 'Nõudega sõidukite arv',
        series: 'Sõidukiseeria',
        platform: 'Mudeli platvorm',
        activity_region: 'Tegevuspiirkond',
        activity_vehicleNum: 'Sõidukite arv',
        number_of_claims: 'Nõuete arv',
        activity_vehicle: 'Tegevussõiduk',
        vehicle_total_num: 'Sõidukite koguarv',
    },
    // 哈萨克
    kkKZ: {
        activity_code: 'Әрекет коды',
        activity_name: 'Әрекет атауы',
        responsible_party: 'Жауапты тарап',
        release_date: 'Шығарылған күні',
        data_sources: 'Дереккөздер',
        recall_campaign_type: 'Қызмет көрсету кампаниясының түрі',
        service_activity_code: 'Қызмет көрсету әрекетінің коды',
        service_activity_name: 'Қызмет көрсету әрекетінің атауы',
        buyout_company: 'Сатып алу компаниясы',
        audit_company: 'Аудит компаниясы',
        currency: 'Валюта',
        money: 'Сома',
        start_date: 'Басталу күні',
        end_date: 'Аяқталу күні',
        failure_mode: 'Сәтсіздік режимі',
        activity_programme: 'Әрекет бағдарламасы',
        improve_handling: 'Жақсарту шаралары',
        activity_information: 'Әрекет туралы ақпарат',
        vehicle_involved_list: 'Аяқталмаған көліктер тізімі',
        claim_vehicles_list: 'Талап қойылған көліктер тізімі',
        claim_statistics: 'Талап статистикасы',
        technical_document_attachments: 'Техникалық құжаттардың тіркемелері',
        vin: 'VIN',
        is_complete: 'Аяқталды ма?',
        warranty_claims: 'Кепілдік талабының нөмірі',
        customer: 'Басты дистрибьютор коды',
        claim_proportion: 'Талаптарды орындау пайызы',
        claim_settled_amount: 'Талап бойынша есептелген сома',
        is_claim_again: 'Қайталанатын талап па?',
        cancel_succeed: 'Сәтті болды',
        number_of_vehicles_involved: 'Аяқталмаған көліктер саны',
        number_of_vehicles_in_which_the_claim_occurred: 'Талап қойылған көліктер саны',
        series: 'Автокөлік сериясы',
        platform: 'Модель платформасы',
        activity_region: 'Әрекет аймағы',
        activity_vehicleNum: 'Көліктер саны',
        number_of_claims: 'Талаптар саны',
        activity_vehicle: 'Әрекет көлігі',
        vehicle_total_num: 'Көліктердің жалпы саны',
    },
    // 希伯来语
    heIL: {
        activity_code: 'קוד פעילות',
        activity_name: 'שם הפעילות',
        responsible_party: 'הצד האחראי',
        release_date: 'תאריך שחרור',
        data_sources: 'מקורות נתונים',
        recall_campaign_type: 'סוג קמפיין שירות',
        service_activity_code: 'קוד פעילות שירות',
        service_activity_name: 'שם פעילות שירות',
        buyout_company: 'חברת רכישה',
        audit_company: 'חברת ביקורת',
        currency: 'מטבע',
        money: 'סכום',
        start_date: 'תאריך התחלה',
        end_date: 'תאריך סיום',
        failure_mode: 'מצב כשל',
        activity_programme: 'תוכנית הפעילות',
        improve_handling: 'צעדי שיפור',
        activity_information: 'מידע על הפעילות',
        vehicle_involved_list: 'רשימת רכבים שלא הושלמו',
        claim_vehicles_list: 'רשימת רכבים עם תביעות',
        claim_statistics: 'סטטיסטיקת תביעות',
        technical_document_attachments: 'קובצי מסמכים טכניים מצורפים',
        vin: 'VIN',
        is_complete: 'האם הושלם?',
        warranty_claims: 'מספר תביעה',
        customer: 'קוד הסוכן הראשי',
        claim_proportion: 'אחוז ביצוע התביעה',
        claim_settled_amount: 'סכום התביעה שנערך',
        is_claim_again: 'האם זו תביעה חוזרת?',
        cancel_succeed: 'הביטול הצליח',
        number_of_vehicles_involved: 'מספר רכבים שלא הושלמו',
        number_of_vehicles_in_which_the_claim_occurred: 'מספר רכבים עם תביעות',
        series: 'סדרת הרכב',
        platform: 'פלטפורמת הדגם',
        activity_region: 'אזור הפעילות',
        activity_vehicleNum: 'מספר רכבים',
        number_of_claims: 'מספר תביעות',
        activity_vehicle: 'רכב פעילות',
        vehicle_total_num: 'סך כל מספר הרכבים',
    },
};
